<template lang="pug">
  .home-ugc-carousel-vue.container.xs-f-small.max-at-tweak
    .row.text-container
      .image-wrap-inner
        ImgBox(:mediaId="14061")
      .ugc-title.xs-f-xlarge.sm-f-xxxlarge.md-f-grande.max-at-tweak
        p.xs-text-center.md-text-left.f-secondary.capitalize(data-mr-ass="primary-title") {{primaryTitle}}
        p.xs-text-center.md-text-left.f-secondary.capitalize(data-mr-ass="secondary-title") {{secondaryTitle}}

    .row
      .xs-12
        LazyComponent(rootMargin="400px")
          template(#default="{ shown }")
            AutomaticStaticCarousel(
              :images="images"
              :imageWidth="imageWidth"
              :imageHeight="imageHeight"
              v-if="shown && images && images.length"
            )
</template>

<script>
  import LazyComponent from "../LazyComponent";
  import ImgBox from '@components/imgBox';

  export default {
    name: "UgcHomeCarousel",
    components: {
      ImgBox,
      AutomaticStaticCarousel: () => import('../Carousels/AutomaticStaticCarousel'),
      LazyComponent,
    },

    props: {
      images: {
        type: Array,
        required: true
      },

      primaryTitle: {
        type: String,
        default: ''
      },

      secondaryTitle: {
        type: String,
        default: ''
      },

      imageWidth: {
        type: Number,
        default: 200,
      },

      imageHeight: {
        type: Number,
        default: 200,
      },
    },
  };
</script>

<style lang="stylus">

.text-container
  display flex
  gap 1em
  justify-content center
  padding 1.5rem 0
  @media mq-mobile
    flex-direction column
    padding 0 1rem
  @media mq-desktop-plus
    width 45%
  @media mq-tablet
    width 80%
.image-wrap-inner
  display flex
  align-items center
  justify-content end
  @media mq-mobile
    justify-content center
  div
    height 7em
    width 7em
</style>
